var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemaClaro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.78 85.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.78,42.89c0,4.93-13.57,7.12-15.34,11.41s6.13,15.57,2.78,18.92c-3.35,3.35-14.48-4.62-18.92-2.78-4.29,1.78-6.48,15.34-11.41,15.34s-7.12-13.57-11.41-15.34c-4.44-1.84-15.57,6.13-18.92,2.78-3.35-3.35,4.62-14.48,2.78-18.92-1.78-4.29-15.34-6.48-15.34-11.41s13.57-7.12,15.34-11.41c1.84-4.44-6.13-15.57-2.78-18.92s14.48,4.62,18.92,2.78c4.29-1.78,6.48-15.34,11.41-15.34s7.12,13.57,11.41,15.34c4.44,1.84,15.57-6.13,18.92-2.78s-4.62,14.48-2.78,18.92c1.78,4.29,15.34,6.48,15.34,11.41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemaClaro);
export default __webpack_public_path__ + "static/media/temaClaro.44d5b7aaa88dafbfba5569dd07a5b2b9.svg";
export { ForwardRef as ReactComponent };